var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.oneArrows || _vm.manyArrows
      ? _c(
          "div",
          {
            staticClass: "vfc-separately-navigation-buttons",
            class: "vfc-" + _vm.fConfigs.arrowsPosition
          },
          [
            _c(
              "div",
              {
                class: { "vfc-cursor-pointer": _vm.allowPreDate },
                on: {
                  click: function($event) {
                    return _vm.$parent.PreMonth(
                      _vm.oneArrows ? 0 : _vm.calendarKey
                    )
                  }
                }
              },
              [
                _vm._t("navigationArrowLeft", function() {
                  return [
                    _c("div", {
                      staticClass: "vfc-arrow-left",
                      class: { "vfc-disabled": !_vm.allowPreDate }
                    })
                  ]
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: { "vfc-cursor-pointer": _vm.allowNextDate },
                on: {
                  click: function($event) {
                    return _vm.$parent.NextMonth(
                      _vm.oneArrows ? 0 : _vm.calendarKey
                    )
                  }
                }
              },
              [
                _vm._t("navigationArrowRight", function() {
                  return [
                    _c("div", {
                      staticClass: "vfc-arrow-right",
                      class: { "vfc-disabled": !_vm.allowNextDate }
                    })
                  ]
                })
              ],
              2
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b71995a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b71995a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-functional-calendar/src/components/Arrows.vue
// module id = 536
// module chunks = 1